import { formatUSDShort } from "@/web/lib/formatting";
import type { Property } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  property: Property;
};

export function createMaxBudgetCompleted(props: Props & { id?: string }): SmbActionDefinition {
  const { property, id = `max-budget:done:${property.id.toString()}` } = props;
  const maxPrice = property.userMaxPrice;
  const formattedMax = maxPrice ? formatUSDShort(maxPrice.value) : undefined;
  return {
    id,
    category: "negotiate",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="negotiate"
        badge="Price"
        title={formattedMax ? `Max budget: ${formattedMax}` : "Max budget set"}
        details={{
          title: "Max budget",
          children: (
            <div className="flex flex-col gap-2">
              <p className="font-medium">{property.address.addressLine1}</p>
              {formattedMax ? <p>You're willing to pay up to {formattedMax}.</p> : null}
              {maxPrice?.note ? <p className="opacity-70">"{maxPrice.note}"</p> : null}
            </div>
          ),
        }}
      />
    ),
  };
}
